import HTTP from '../common/http-common';

const END_POINT = '/user';

const changePassword = (userName,  newPassword) => HTTP.post(END_POINT + "/change-password",
 {newPassword: newPassword, userName: userName});

export {
    changePassword
}